import classNames from 'classnames';
import { t } from 'i18next';
import { DateTime } from 'luxon';
import { ClassName } from 'types/ClassName';
import ITimeRange from 'types/TimeRange';
import TimeRangeType from 'types/TimeRangeType';
import { Nullable } from 'types/util/Nullable';
import { getFormattedDateRangeByType } from 'utils/timeRangeUtils';
import BasicArrowedDateRange, { BasicArrowDateRangePosition } from '../BasicArrowedDateRange/BasicArrowedDateRange';

export interface IArrowedDateRangeProps {
  timeRange: Nullable<ITimeRange<DateTime>>;
  forward: () => void;
  back: () => void;
  forwardEnabled: () => boolean;
  backEnabled: () => boolean;
  timeRangeType: TimeRangeType;
  datePosition?: BasicArrowDateRangePosition;
  className?: ClassName;
}

function ArrowedDateRange({
  timeRange,
  forward,
  back,
  forwardEnabled,
  backEnabled,
  timeRangeType,
  datePosition,
  className,
}: IArrowedDateRangeProps) {
  const shouldRenderArrows = timeRangeType !== TimeRangeType.CUSTOM && timeRangeType !== TimeRangeType.ALL_TIME;

  function getLabel() {
    if (timeRangeType !== TimeRangeType.ALL_TIME) {
      if (!timeRange) {
        return '';
      }

      return getFormattedDateRangeByType(timeRange, timeRangeType);
    } else {
      return t('All Time');
    }
  }

  return (
    <div className={classNames('arrowed-date-range', className)}>
      <BasicArrowedDateRange
        label={getLabel()}
        forward={shouldRenderArrows ? forward : undefined}
        back={shouldRenderArrows ? back : undefined}
        forwardEnabled={forwardEnabled()}
        backEnabled={backEnabled()}
        datePosition={datePosition}
      />
    </div>
  );
}

export default ArrowedDateRange;
